export default {
  PlayerHighlight: true,
  HubPages: false,
  MatchdayTakeover: false,
  TempSocialFeed: false,
  WhereToStream: false,
  PlayerProfileStats: false
}
